'use client'

import { type ReactNode, useEffect } from 'react'
import { useCoreContext } from './components/context'

type Props = {
  children?: ReactNode
}

export default function RootPage({ children }: Props) {
  const { actions } = useCoreContext()
  useEffect(() => {
    actions.load()
  }, [])

  return <>{children}</>
}
